import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as circularAPI from "../../api/circular";

const initialState = {
  data: null,
  targetAudience: null,
  activeCircular: null,
  additionalInfo: {
    idDepartment: null,
    year: null,
    idProgram: null,
    idTarget:null
  },
  loading: false,
  redirect: false,
  perPage: 10,
  page: 1,
  offset: 0,
};

const getAllCircular = createAsyncThunk(
  "circular/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.getAllCircular(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const addCircular = createAsyncThunk(
  "circular/add",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.addCircular(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const updateCircular = createAsyncThunk(
  "circular/update",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.updateCircular(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const deleteCircular = createAsyncThunk(
  "circular/delete",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.deleteCircular(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getTargetAudience = createAsyncThunk(
  "circular/getTargetAudience",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.getTargetAudience(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getStudentsById = createAsyncThunk(
  "circular/getStudentsById",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.getStudentsById(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getBatchByDepartmentID = createAsyncThunk(
  "circular/getBatchByDepartmentID",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.getBatchByDepartmentID(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getStudentsByBatchYear = createAsyncThunk(
  "circular/getStudentsByBatchYear",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.getStudentsByBatchYear(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const updateCurrentYear = createAsyncThunk(
  "circular/updateCurrentYear",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.updateCurrentYear(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const searchStudentForMigration = createAsyncThunk(
  "circular/searchStudentForMigration",
  async (params, { rejectWithValue }) => {
    try {
      const res = await circularAPI.searchStudentForMigration(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const circularSlice = createSlice({
  name: "circular",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    handleAddtionalInfo: (state, action) => {
      // const index = state.targetAudience.findIndex(
      //   (_el) => _el.id === action.payload
      // );
      const index = action.payload;
      state.additionalInfo.idTarget =
        state?.targetAudience[index]?.id;
      state.additionalInfo.idDepartment =
        state?.targetAudience[index]?.idDepartment;
      state.additionalInfo.idProgram = state?.targetAudience[index]?.idProgram;
      state.additionalInfo.year = state?.targetAudience[index]?.year;
    },
    setActiveCircular: (state, action) => {
      state.activeCircular = action.payload;
    },
    setRidirect: (state) => {
      state.redirect = false;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: {
    [addCircular.pending]: (state) => {
      state.loading = true;
    },
    [addCircular.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action?.payload?.circularAdded);
    },
    [addCircular.rejected]: (state,action) => {
      state.loading = false;
      toast.error(action?.payload);
    },

    [getAllCircular.pending]: (state) => {},
    [getAllCircular.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.redirect = false;
    },
    [getAllCircular.rejected]: (state) => {},

    [deleteCircular.pending]: (state) => {
      state.loading = true;
    },
    [deleteCircular.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteCircular.rejected]: (state) => {
      state.loading = false;
    },

    [getTargetAudience.pending]: (state) => {
      state.loading = true;
    },
    [getTargetAudience.fulfilled]: (state, action) => {
      state.loading = false;
      state.targetAudience = action.payload;
    },
    [getTargetAudience.rejected]: (state) => {
      state.loading = false;
    },

    [getStudentsById.pending]: (state) => {
      state.loading = true;
    },
    [getStudentsById.fulfilled]: (state, action) => {
      state.loading = false;
      state.studentsById = action.payload;
    },
    [getStudentsById.rejected]: (state) => {
      state.loading = false;
    },

    [getBatchByDepartmentID.pending]: (state) => {
      state.loading = true;
    },
    [getBatchByDepartmentID.fulfilled]: (state, action) => {
      state.loading = false;
      state.batchByDepartmentID = action.payload;
    },
    [getBatchByDepartmentID.rejected]: (state) => {
      state.loading = false;
    },

    [getStudentsByBatchYear.pending]: (state) => {
      state.loading = true;
    },
    [getStudentsByBatchYear.fulfilled]: (state, action) => {
      state.loading = false;
      state.studentsByBatchYear = action.payload;
    },
    [getStudentsByBatchYear.rejected]: (state) => {
      state.loading = false;
    },

    [updateCurrentYear.pending]: (state) => {
      state.loading = true;
    },
    [updateCurrentYear.fulfilled]: (state, action) => {
      state.loading = false;
      state.updatedCurrentYear = action.payload;
      toast.success(action.payload);
    },
    [updateCurrentYear.rejected]: (state,action) => {
      state.loading = false;
      toast.error(action.payload);
    },

    [searchStudentForMigration.pending]: (state) => {
      state.loading = true;
    },
    [searchStudentForMigration.fulfilled]: (state, action) => {
      state.loading = false;
      state.searchStudentMigration = action.payload;
    },
    [searchStudentForMigration.rejected]: (state) => {
      state.loading = false;
    },

    [updateCircular.pending]: (state) => {
      state.loading = true;
    },
    [updateCircular.fulfilled]: (state, action) => {
      state.loading = false;
      state.redirect = true;
      toast.success(action.payload);
    },
    [updateCircular.rejected]: (state,action) => {
      state.loading = false;
      toast.error(action.payload);
    },
  },
});

const {
  resetState,
  handleAddtionalInfo,
  setActiveCircular,
  setRidirect,
  setPerPage,
  setOffset,
  setPage,
} = circularSlice.actions;
export default circularSlice.reducer;

export {
  resetState,
  getTargetAudience,
  getAllCircular,
  deleteCircular,
  addCircular,
  handleAddtionalInfo,
  setActiveCircular,
  updateCircular,
  setRidirect,
  setPerPage,
  setOffset,
  setPage,
  getStudentsById,
  getBatchByDepartmentID,
  getStudentsByBatchYear,
  updateCurrentYear,
  searchStudentForMigration,
};
